module.exports = __webpack_public_path__ + "static/media/teams-happy-people-logo.1337c963.svg";